import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { AssetsService } from '@app/features/main/views/assets/assets.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'assets-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class AssetsIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private assetsService = inject(AssetsService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.assetsService.assetAdded$,
      this.assetsService.assetUpdated$,
      this.assetsService.assetsDeleted$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.assetsService.loadAssetsPage(selectParams)
      .pipe(first(), map(assets => assets.first()));
  }
}
